// extracted by mini-css-extract-plugin
export default {"table-wrapper":"table-wrapper_table-wrapper__syq3d"};